import { render, staticRenderFns } from "./variable-list.vue?vue&type=template&id=4d4c8e88"
import script from "./variable-list.vue?vue&type=script&lang=js"
export * from "./variable-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports